// src/App.tsx
import React, { useEffect } from 'react';
import { Button } from 'antd';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { routes } from './routes/routes'; // Import routes
import ProtectedRoute from './routes/ProtectedRoute'; // Protected routes handler
import AppLayout from './layout/AppLayout'; // Layout wrapper

import GlobalLoader from './components/GlobalLoader';

import { useInstallPrompt } from './hooks/useInstallPrompt';
import { requestForToken } from './firebase/requestPermission';
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebase/firebase-config';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./assets/css/style.css";


const App = () => {
  const { deferredPrompt, promptInstall } = useInstallPrompt();
  useEffect(() => {
    Notification.requestPermission().then(permission => {
      console.log('Notification permission:', permission);
      if (permission === 'granted') {
        requestForToken(); // Request FCM token after permission granted

        onMessage(messaging, (payload) => {
          console.log('Foreground notification:', payload);
          const { title, body } = payload.notification || {};

          if (title) {
            try {
              new Notification(title, {
                body: body || '',
                icon: 'http://localhost:3000/favicon.ico',
                requireInteraction: true, // keeps notification visible until user dismisses
              });
            } catch (error) {
              console.error('Notification error:', error);
            }
          }
        });
      } else {
        console.warn('Notification permission not granted');
      }
    });
  }, []);
  return (
    <>
      <GlobalLoader />
      {deferredPrompt && (
        <Button type="primary" onClick={promptInstall}>
          Install App
        </Button>
      )}
      <Router>
        <Routes>
          {routes.map(({ path, element, protected: isProtected }) => {
            if (isProtected) {
              return (
                <Route element={<ProtectedRoute />} key={path}>
                  <Route element={<AppLayout />}>
                    <Route path={path} element={element} />
                  </Route>
                </Route>
              );
            }
            return <Route path={path} element={element} key={path} />;
          })}
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
